import gql from "graphql-tag";
import {LocationFragment} from "../../Queries/Location";
import {OrganizationFragment} from "../../Queries/Organization";

const LiveFlightEditorFlightFragment = gql`
fragment LiveFlightEditorFlightFragment on FlightNode {
    _id
    state
    desig
    scheduledFlightDate
    callSign
    liveEditedState
    paxIDList {
        _id
        _rev
        lastName
        firstName
        scheduledOrder
        scheduledGroup
        chargeCode
        employerID {
            _id
            name
        }
        transitType
        departureID {
            _id
            name
        }
        destinationID {
            _id
            name
        }
        paxWeight
        bagWeight
        bagCount
        classType
    }
    cgoIDList {
        _id
        name
        scheduledOrder
        scheduledGroup
        transitType
        chargeCode
        departureID {
            _id
            name
        }
        destinationID {
            _id
            name
        }
        weight
        attentionTo
        initials
        notes
        classType
    }
    legs
    legsArray {
        bagCount
        bagWeight
        cgoCount
        cgoWeight
        chosen
        departure
        departureID
        destination
        destinationID
        order
        paxCount
        paxWeight
        usefulLoad
        seats
        paxIDs {
            _id
            lastName
            firstName
            classType
            employerID {
                _id
                name
            }
            chargeCode
            paxWeight
            bagWeight
            bagCount
            departureID {
                _id
                name
            }
            destinationID {
                _id
                name
            }
            personID {
                _id
                dob
                nation
                credentials {
                    _id
                    key
                    type
                    expiration
                }
            }
            transitType
        },
        cgoIDs {
            _id
            name
            weight
            approvedBy
            checkedInTime
            classType
            chargeCode
            departureID {
                _id
                name
            }
            destinationID {
                _id
                name
            }
            deliveredBy
            attentionTo
            transitType
        }
    }
    tpID {
        ...OrganizationFragment
    }
    pilot {
        _id
        name {
            lastName
            firstName
        }
    }
    copilot {
        _id
        name {
            lastName
            firstName
        }
    }
    contract {
        _id
        name
    }
    aircraftID {
        _id
        tailNum
        model
        maxSeats
        maxLoad
    }
    departureID {
        ...LocationFragment
    }
}
${OrganizationFragment}
${LocationFragment}
`

export const GET_FLIGHT = gql`
    query GetFlight(
        $flightId: ID!
    ){
        getFlight(_id: $flightId){
            ...LiveFlightEditorFlightFragment
        }
    }
    ${LiveFlightEditorFlightFragment}
`

export const SET_FLIGHT = gql`
    mutation SetFlight(
        $payload: FlightNodeInput!
        $orgID: ID!
    ){
        setFlight(payload: $payload, orgID: $orgID){
            ...LiveFlightEditorFlightFragment
        }
    }
    ${LiveFlightEditorFlightFragment}
`

export const SET_LOCKED_STATE = gql`
mutation LiveFlightEditor_SetLockedState($flightID: ID!, $locked: Boolean!) {
    setFlightLocked(flightID: $flightID, locked: $locked){
        ...LiveFlightEditorFlightFragment
    }
}
${LiveFlightEditorFlightFragment}
`